import { render, staticRenderFns } from "./ModalSection.vue?vue&type=template&id=3185f7ef&scoped=true"
import script from "./ModalSection.vue?vue&type=script&lang=js"
export * from "./ModalSection.vue?vue&type=script&lang=js"
import style0 from "./ModalSection.vue?vue&type=style&index=0&id=3185f7ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185f7ef",
  null
  
)

export default component.exports